import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/customer_/$customerId/contacts/_list/$contactId/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
